import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center-center absolute z-10 w-full p-8 text-center"
}
const _hoisted_2 = {
  key: 0,
  class: "tablet:h4"
}
const _hoisted_3 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative flex flex-col", {'col-span-full': $props.banner.fullWidth}]),
    style: {"height":"var(--collection-grid-item-height)"}
  }, [
    ($props.banner.title || $props.banner.text)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($props.banner.title)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString($props.banner.title), 1))
            : _createCommentVNode("", true),
          ($props.banner.text)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "m-auto max-w-prose text-16",
                innerHTML: $props.banner.text
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($props.banner.image)
      ? (_openBlock(), _createBlock(_component_v_image, {
          key: 1,
          lazyloaded: "",
          source: $props.banner.image,
          alt: $props.banner.title,
          class: "h-full w-full rounded-8 object-cover"
        }, null, 8, ["source", "alt"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "absolute inset-0 bg-black-900",
      style: _normalizeStyle(`opacity: ${$props.banner.overlayOpacity}`)
    }, null, 4)
  ], 2))
}